import { HttpClient, HttpParams } from '@angular/common/http';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ResidentialService } from 'src/app/questionarie-signup/questionnaire-residential/residential.service';
import { MatTable } from '@angular/material/table';
import {MatSort, Sort} from '@angular/material/sort';

import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { EnergyProvidersModalComponent } from '../../admin-utility/energy-providers-modal/energy-providers-modal.component';
import { SnackbarComponent } from '../../snackbar/snackbar.component';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';

// import { AdminUtilityReportComponent } from '../admin-utility/admin-utility-report/admin-utility-report.component'
import { ItemsList } from '@ng-select/ng-select/ng-select/items-list';
import { environment } from '../../../environments/environment';
import { IMyDpOptions, IMyDate } from 'mydatepicker';
import * as moment from 'moment-timezone';
import { Block } from '../../shared/models/block';
@Component({
  selector: 'app-hg-energy-providers-utility-info',
  templateUrl: './hg-energy-providers-utility-info.component.html',
  styleUrls: ['./hg-energy-providers-utility-info.component.css'],
})
export class HgEnergyProvidersUtilityInfoComponent implements OnInit {
  @ViewChild('mytable') mytable = new MatSort();

  @ViewChild('providerPaginator', { read: MatPaginator })

  providerPaginator: MatPaginator;
  @ViewChild(MatTable, { static: true })
  table: MatTable<any>;
  blocks: Block[];
  dataSource: MatTableDataSource<Block>;
  displayedColumns: string[] = [
    'action',
    'ProviderName',
    'PromoCode',
    'ProviderEmail',

    'ProviderOperationHours',
    'ProviderPhone',
    'Provider_duns',
    'RecipientEmail',
    'Status',
    'UtilityContact',
    'UtilityName',
  ];
  selected: string;
  providers = [
    // { value: 'All', text: 'All' },
    { value: 'Gexa Energy', text: 'Gexa Energy' },
    { value: '4Change Energy', text: '4Change Energy' },
    { value: 'Chariot Energy', text: 'Chariot Energy' },
    { value: 'Pulse Power', text: 'Pulse Power' },
    { value: 'New Power Texas', text: 'New Power Texas' },
    { value: 'Bulb', text: 'Bulb' },
    { value: 'Pronto Power', text: 'Pronto Power' },
    { value: 'Texpo Energy', text: 'Texpo Energy' },
  ];
  constructor(
    private http: HttpClient,
    private router: Router,
    private residentialService: ResidentialService,
    public dialog: MatDialog,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.getEnergyProvidersReportInfo();
  }
  getEnergyProvidersReportInfo() {
    this.residentialService
      .getEnergyProvidersReportInfo()
      .subscribe((response: any) => {
        // console.log(response);
        this.blocks = response;
        this.dataSource = new MatTableDataSource<Block>(this.blocks);
        this.dataSource.paginator = this.providerPaginator;
        this.dataSource.sort = this.mytable;

      });
  }
  highlight(id, event) {}
  openDialog(action, itemData?) {
    // obj.action = action;
    const dialogRef = this.dialog.open(EnergyProvidersModalComponent, {
      width: '1000px',
      data: { pageValue: this.blocks, action, itemData },
    });

    dialogRef.afterClosed().subscribe((result) => {
      // this.dialogValue = result.data;
      this.getEnergyProvidersReportInfo();
    });
  }
  onChangeProvider(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    // if (filterValue == 'All') {
    //   this.getEnergyProvidersReportInfo();
    // } else {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    // }
  }
}
